/**
 * "When will this be deleted?", on the dossier itself.
 *
 * The BRIEF asks for the window to be *shown to the user*, so it sits on the
 * dossier card rather than in a settings page nobody opens. Two states, and
 * neither depends on colour: the ordinary countdown is a neutral badge with a
 * clock, and an expired window is an outlined badge with a different icon AND
 * a different sentence (WCAG 2.2 AA — never colour alone).
 */
import { Clock, TimerOff } from 'lucide-react'

import { Icon } from '@/components/Icon'
import { Badge } from '@/components/ui/badge'
import { retentionPhrase } from '@/features/retention/retention'
import { useI18n } from '@/i18n'

export function RetentionBadge({
  deleteAfter,
  now,
}: {
  deleteAfter: string | null | undefined
  now?: Date
}) {
  const { t } = useI18n()
  const phrase = retentionPhrase(deleteAfter, now)
  return (
    <Badge
      variant={phrase.due ? 'outline' : 'neutral'}
      data-testid="retention-badge"
      data-due={phrase.due ? 'true' : 'false'}
    >
      <Icon icon={phrase.due ? TimerOff : Clock} />
      {t(phrase.key, phrase.vars)}
    </Badge>
  )
}
